export default "__VITE_ASSET__B6vO4i3$__"